import React, { Component } from "react";
import InputRow from "./InputRow";
import Loading from "./Loading";
import PropTypes from "prop-types";
import Parent4 from "./Parent4";

export default class Sources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      sourceData: [],
      selectedSources: [],
      otherSource: this.props.otherSource ? this.props.otherSource : "",
      participatedEvent: false,
      prefixData: [],
      guardianRelationship: this.props.sourceInfo.guardianRelationship
        ? this.props.sourceInfo.guardianRelationship
        : "",
      guardianPrefix: "",
      guardianFName: this.props.sourceInfo.guardianFName
        ? this.props.sourceInfo.guardianFName
        : "",
      guardianLName: this.props.sourceInfo.guardianLName
        ? this.props.sourceInfo.guardianLName
        : "",
      guardianPhone: this.props.sourceInfo.guardianPhone
        ? this.props.sourceInfo.guardianPhone
        : "",
      guardianEmail: this.props.sourceInfo.guardianEmail
        ? this.props.sourceInfo.guardianEmail
        : "",
      guardianSuffix: this.props.sourceInfo.guardianSuffix
        ? this.props.sourceInfo.guardianSuffix
        : "",
      loading: true,
      disableAll: false,
      error: "",
      relationshipData: [],
    };
    this.relationshipUpdate = this.relationshipUpdate.bind(this);
  }

  relationshipUpdate(e) {
    if (parseInt(e) === this.props.fatherId) {
      const fatherInfo = this.props.fatherInfo;
      const sources = this.props.selectedSources;
      const otherSource = this.props.otherSource;
      const guardianSuffix = this.props.guardianSuffix;
      this.setState({
        guardianRelationship: this.props.fatherId,
        guardianPrefix: fatherInfo.prefix || fatherInfo.RelationPrefix || 0,
        guardianFName:
          fatherInfo.firstName || fatherInfo.RelationFirstName || "",
        guardianPhone: fatherInfo.mobileNumber || fatherInfo.MobileNumber || "",
        guardianEmail: fatherInfo.email || fatherInfo.RelationEmail || "",
        disableAll: true,
        selectedSources: sources,
        otherSource: otherSource,
        guardianSuffix: guardianSuffix,
      });
      this.props.collectState("Sources", {
        guardianRelationship: this.props.fatherId,
        guardianPrefix: fatherInfo.prefix || fatherInfo.RelationPrefix || 0,
        guardianFName:
          fatherInfo.firstName || fatherInfo.RelationFirstName || "",
        guardianPhone: fatherInfo.mobileNumber || fatherInfo.MobileNumber || "",
        guardianEmail: fatherInfo.email || fatherInfo.RelationEmail || "",
        guardianSuffix: guardianSuffix,
        selectedSources: sources,
        otherSource: otherSource,
      });
    } else if (parseInt(e) === this.props.motherId) {
      const motherInfo = this.props.motherInfo;
      const sources = this.props.selectedSources;
      const otherSource = this.props.otherSource;
      const guardianSuffix = this.props.guardianSuffix;
      this.setState({
        guardianRelationship: this.props.motherId,
        guardianPrefix: motherInfo.prefix || motherInfo.RelationPrefix || 0,
        guardianFName:
          motherInfo.firstName || motherInfo.RelationFirstName || "",
        guardianLName:
          motherInfo.familyName || motherInfo.RelationLastName || "",
        guardianPhone: motherInfo.mobileNumber || motherInfo.MobileNumber || "",
        guardianEmail: motherInfo.email || motherInfo.RelationEmail || "",
        guardianSuffix: guardianSuffix,
        disableAll: true,
        selectedSources: sources,
        otherSource: otherSource,
      });
      this.props.collectState("Sources", {
        guardianRelationship: this.props.motherId,
        guardianPrefix: motherInfo.prefix || motherInfo.RelationPrefix || 0,
        guardianFName:
          motherInfo.firstName || motherInfo.RelationFirstName || "",
        guardianLName:
          motherInfo.familyName || motherInfo.RelationLastName || "",
        guardianPhone: motherInfo.mobileNumber || motherInfo.MobileNumber || "",
        guardianEmail: motherInfo.email || motherInfo.RelationEmail || "",
        guardianSuffix: guardianSuffix,
        selectedSources: sources,
        otherSource: otherSource,
      });
    } else {
      if (
        [this.props.fatherId, this.props.motherId].indexOf(
          parseInt(this.state.guardianRelationship)
        ) !== -1
      ) {
        this.setState({
          guardianRelationship: e,
          guardianPrefix: "",
          guardianFName: "",
          guardianLName: "",
          guardianPhone: "",
          guardianEmail: "",
          guardianSuffix: "",
        });
        this.props.collectState("Sources", {
          guardianRelationship: e,
          guardianPrefix: "",
          guardianFName: "",
          guardianLName: "",
          guardianPhone: "",
          guardianEmail: "",
          guardianSuffix: "",
          selectedSources: this.state.selectedSources,
          otherSource: this.state.otherSource,
        });
      } else {
        this.setState({
          guardianRelationship: e,
          guardianPrefix: this.state.guardianPrefix,
          guardianFName: this.state.guardianFName,
          guardianLName: this.state.guardianLName,
          guardianPhone: this.state.guardianPhone,
          guardianEmail: this.state.guardianEmail,
          guardianSuffix: this.state.guardianSuffix,
        });
        this.props.collectState("Sources", {
          guardianRelationship: e,
          guardianPrefix: this.state.guardianPrefix,
          guardianFName: this.state.guardianFName,
          guardianLName: this.state.guardianLName,
          guardianPhone: this.state.guardianPhone,
          guardianEmail: this.state.guardianEmail,
          guardianSuffix: this.state.guardianSuffix,
          selectedSources: this.state.selectedSources,
          otherSource: this.state.otherSource,
        });
      }
      this.setState({ guardianRelationship: e, disableAll: false });
    }
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/source/getsources`)
      .then((res) => res.json())
      .then((res) => {
        if (res.length) {
          this.setState({ sourceData: res, loading: false });
        }
        if (this.props.sources.length) {
          const newSource = [];
          this.props.sources.forEach((element) => {
            newSource.push(element.Id);
          });
          this.setState({ selectedSources: newSource });
        }
      })
      .then(() =>
        fetch(
          `${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`
        )
          .then((res) => res.json())
          .then((res) => {
            this.setState({ prefixData: res });
            if (res.length) {
              this.setState({
                guardianPrefix: "",
              });
            }
          })
          .then(() =>
            fetch(
              `${process.env.REACT_APP_API_URL}/api/guardianinformation/getrelations`
            )
          )
          .then((res) => res.json())
          .then((res) => {
            this.setState({ relationshipData: res, loading: false });
            if (res.length) {
              this.setState({
                guardianRelationship:
                  parseInt(this.props.sourceInfo.guardianRelationship) || "",
              });
              if (
                parseInt(this.props.relationshipInfo.RelationType) ===
                  this.props.fatherId ||
                parseInt(this.props.relationshipInfo.RelationType) ===
                  this.props.motherId
              ) {
                this.setState({ disableAll: true });
              }
            }
          })
      )
      .catch((err) => console.log(err));
  }

  render() {
    const validationError = this.props.error;
    const {
      prefixData,
      guardianRelationship,
      guardianPrefix,
      guardianFName,
      guardianLName,
      guardianPhone,
      guardianEmail,
      guardianSuffix,
      disableAll,
      error,
      relationshipData,
      loading,
      sourceData,
      selectedSources,
      otherSource,
    } = this.state;
    if (loading) {
      return <Loading />;
    }
    // eslint-disable-next-line prefer-const
    let displaySources = [];
    sourceData.forEach((element, index) => {
      displaySources.push(
        <label key={index}>
          <input
            type="checkbox"
            value={element.Id}
            name="sources"
            checked={selectedSources.indexOf(element.Id) !== -1}
            onChange={(e) => {
              if (selectedSources.indexOf(parseInt(e.target.value)) === -1) {
                this.props.collectState("Sources", {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianLName: guardianLName,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail,
                  guardianSuffix: guardianSuffix,
                  selectedSources: [
                    ...this.state.selectedSources,
                    parseInt(e.target.value),
                  ],
                  otherSource: otherSource,
                });
                this.setState({
                  selectedSources: [
                    ...this.state.selectedSources,
                    parseInt(e.target.value),
                  ],
                });
              } else {
                const newSources = [];
                selectedSources.forEach((element) => {
                  if (element !== parseInt(e.target.value)) {
                    newSources.push(parseInt(element));
                  }
                });
                this.setState({ selectedSources: newSources });
                this.props.collectState("Sources", {
                  selectedSources: newSources,
                });
              }
            }}
          />
          {element.value}
        </label>
      );
    });
    return (
      <div className="sources-section">
        <p>
          In this section, please indicate if you have any relationship with
          LGU. Also, indicate how did you learn about us. When ready, click Next
          to navigate to the next section.
          <br />
          <br /> Kindly fill the below fields if any of your immediate family
          members graduated from LGU, will be studying at LGU during the same
          time or are currently working at LGU. Otherwise, leave this section
          empty.
        </p>
        <br />
        <div className="guardian">
          <Parent4
            guardian={true}
            relationshipData={relationshipData}
            relationship={guardianRelationship}
            relationshipUpdate={this.relationshipUpdate}
            prefixData={prefixData}
            onChangePrefix={(val) => {
              this.setState({ guardianPrefix: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: val,
                guardianFName: guardianFName,
                guardianLName: guardianLName,
                guardianPhone: guardianPhone,
                guardianEmail: guardianEmail,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            selectedPrefix={guardianPrefix}
            fName={guardianFName}
            onChangeFName={(val) => {
              this.setState({ guardianFName: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: val,
                guardianLName: guardianLName,
                guardianPhone: guardianPhone,
                guardianEmail: guardianEmail,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            lName={guardianLName}
            onChangeLName={(val) => {
              this.setState({ guardianLName: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: guardianFName,
                guardianLName: val,
                guardianPhone: guardianPhone,
                guardianEmail: guardianEmail,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            mobileNumber={guardianPhone}
            onChangeNumber={(val) => {
              this.setState({ guardianPhone: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: guardianFName,
                guardianLName: guardianLName,
                guardianPhone: val,
                guardianEmail: guardianEmail,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            email={guardianEmail}
            emailRequired={false}
            onChangeEmail={(val) => {
              this.setState({ guardianEmail: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: guardianFName,
                guardianLName: guardianLName,
                guardianPhone: guardianPhone,
                guardianEmail: val,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            status={guardianSuffix}
            suffixRequired={false}
            onChangeSuffix={(val) => {
              this.setState({ guardianSuffix: val });
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: guardianFName,
                guardianLName: guardianLName,
                guardianPhone: guardianPhone,
                guardianEmail: guardianEmail,
                guardianSuffix: val,
                selectedSources: selectedSources,
                otherSource: otherSource,
              });
            }}
            disableAll={disableAll}
            errRelation={
              validationError.guardianRelationship
                ? validationError.guardianRelationship
                : ""
            }
            errPrefix={
              validationError.guardianPrefix
                ? validationError.guardianPrefix
                : ""
            }
            errFName={
              validationError.guardianFName ? validationError.guardianFName : ""
            }
            errMName={
              validationError.guardianMName ? validationError.guardianMName : ""
            }
            errLName={
              validationError.guardianLName ? validationError.guardianLName : ""
            }
            errProfession={
              validationError.guardianProfession
                ? validationError.guardianProfession
                : ""
            }
            errMobile={
              validationError.guardianPhone ? validationError.guardianPhone : ""
            }
            errEmail={
              validationError.guardianEmail ? validationError.guardianEmail : ""
            }
            errSuffix={
              validationError.guardianSuffix
                ? validationError.guardianSuffix
                : ""
            }
          />
        </div>

        <p>
          Where did you hear about us ?&nbsp;
          <span style={{ color: "red" }}>*</span>
        </p>

        <div>{displaySources}</div>
        {selectedSources.includes(16) && (
          <InputRow
            name="text"
            rowName="If others, please specify"
            value={otherSource}
            required={selectedSources.includes(16) ? "*" : ""}
            disabled={selectedSources.includes(16) ? false : true} //16 is the Id of "Other" value
            onChange={(e) => {
              this.props.collectState("Sources", {
                guardianRelationship: guardianRelationship,
                guardianPrefix: guardianPrefix,
                guardianFName: guardianFName,
                guardianLName: guardianLName,
                guardianPhone: guardianPhone,
                guardianEmail: guardianEmail,
                guardianSuffix: guardianSuffix,
                selectedSources: selectedSources,
                otherSource: e,
              });
              this.setState({ otherSource: e });
            }}
          />
        )}

        <hr />
        {/* <p>
          Indicate if you participated in any activity/contest organized by
          LGU*:
        </p>
        <label>
          <input
            type="radio"
            name="participatedEvent"
            checked={participatedEvent}
            onChange={() => {
              this.setState({ participatedEvent: true });
            }}
          />
          &nbsp;Yes
        </label>
        <label style={{ marginLeft: 10 }}>
          <input
            type="radio"
            name="participatedEvent"
            checked={!participatedEvent}
            onChange={() => {
              this.setState({
                participatedEvent: false,
                selectedEventName: "",
              });
            }}
          />
          &nbsp;No
        </label>

        {this.state.participatedEvent && (
          <InputRow
            name="text"
            rowName="Name of the event"
            value={selectedEventName}
            required="*"
            onChange={(e) => {
              this.setState({ selectedEventName: e });
            }}
          />
        )} */}

        {this.props.error.general && (
          <p
            style={{
              color: "red",
              fontSize: 12,
              marginTop: 3,
              marginBottom: 5,
            }}
          >
            {this.props.error.general}
          </p>
        )}
        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}
Sources.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  sources: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
  otherSource: PropTypes.string,
};
